import React, { Component } from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import * as icons from "common/icons";
import Page from "components/Page";
import PageBody from "components/PageBody";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import TileBodyMessage from "components/TileBodyMessage";
import Alert from "components/Alert";
import TileActionsBar from "components/TileActionsBar";
import FarmHomePageHead from "containers/FarmHome/FarmHomePageHead";
import MyFarmAccessRequestApprovals from "containers/Dashboard/MyFarmAccessRequestApprovals";
import FarmAccessList from "./FarmAccessList";
import PendingFarmAccessInvitations from "./PendingFarmAccessInvitations";
import { modal } from "containers/App/_actions";
import { fetchFarmAccess } from "./_actions";
import ActionLink from "components/ActionLink";
import { Redirect } from "react-router";
import Loader from "components/Loader";

class FarmAccess extends Component {
    componentDidMount() {
        this._queryFarmAccess();
    }

    _queryFarmAccess = () => {
        const { fetchFarmAccess, farm } = this.props;
        fetchFarmAccess(farm.id);
        this.setState({ isWaiting: false });
    };

    _grantFarmAccess = (accessInvitation) => (e) => {
        if (!accessInvitation) accessInvitation = {};

        const { farm = {}, authContext } = this.props;
        const { access = [], accessInvitations = [] } = farm;
        const iAmAnOwner = access.some((a) => a.accountId === authContext.accountId && a.role === "Owner");
        const iAmAnAdmin = access.some((a) => a.accountId === authContext.accountId && a.role === "Admin");
        const farmHasAnOwner = access.some((a) => a.role === "Owner");
        const farmHasAnOwnerInvite = accessInvitations.some((i) => i.role === "Owner" && i.status === "Pending");
        const canInviteOwner = authContext.isSystemAdmin || iAmAnOwner || (iAmAnAdmin && !farmHasAnOwner && !farmHasAnOwnerInvite);
        this.setState({ modalOpened: true });
        this.props.modal("GrantFarmAccessModal", null, { ...accessInvitation, canInviteOwner, farmId: farm.id });
    };

    componentDidUpdate() {
        const { farm = {} } = this.props;
        const { accessInvitations = [] } = farm;
        const pendingAccessInvitations = accessInvitations.filter((a) => a.status === "Pending" && a.role !== "PublicationAgent");
        if (!this.state.isWaiting && this.state.modalOpened && pendingAccessInvitations.some((p) => p.emailLog && p.emailLog.history.length === 1 && p.emailLog.history[0].type === "Akuaku")) {
            this.setState({ isWaiting: true });
            setTimeout(() => {
                this._queryFarmAccess();
            }, 5000);
        }
    }

    render() {
        const { online, isLoading, farm = {}, authContext, refData } = this.props;
        const { access = [], accessInvitations = [], accessRequests = [] } = farm;
        const referrer = `/app/farm/${farm.id}`;
        const iAmAnOwner = access.some((a) => a.accountId === authContext.accountId && a.role === "Owner");
        const iAmAnAdmin = access.some((a) => a.accountId === authContext.accountId && a.role === "Admin");
        const pendingAccessInvitations = accessInvitations.filter((a) => a.status === "Pending" && a.role !== "PublicationAgent");
        const pendingAccessRequests = accessRequests.filter((a) => a.status === "Pending");
        const isStudent = authContext.accountType === "Student";

        const breadcrumb = [{ name: farm.displayName, to: referrer }, { name: "Farm access" }];

        if (access.length === 0) {
            return <Loader message="Loading..." />;
        }

        if (!authContext.isSystemAdmin && !iAmAnAdmin && !iAmAnOwner) {
            return <Redirect to={`/app/farm/${farm.id}`} />;
        }

        return (
            <Page>
                <FarmHomePageHead breadcrumb={breadcrumb} farm={farm} authContext={authContext} refData={refData} />
                <PageBody>
                    <Panel title="Farm access" referrer={referrer} iconClassName="IconLink--lock">
                        <Alert
                            type="info"
                            text={
                                <span>
                                    Use this screen to manage the <b>organisations</b> that have access to this farm.
                                </span>
                            }
                        />
                        <PanelBody>
                            {online && !isStudent && (
                                <TileActionsBar>
                                    <ul className="ActionsBar-links">
                                        <li>
                                            <ActionLink className="IconLink--arrow-plus" id="add-access-action" onClick={this._grantFarmAccess()}>
                                                <span>Grant farm access</span>
                                            </ActionLink>
                                        </li>
                                    </ul>
                                </TileActionsBar>
                            )}
                            {pendingAccessInvitations.length > 0 && <PendingFarmAccessInvitations online={online} farm={farm} pendingAccessInvitations={pendingAccessInvitations} resend={this._grantFarmAccess} />}
                            {pendingAccessRequests.length > 0 && <MyFarmAccessRequestApprovals online={online} farm={farm} myFarmAccessRequestApprovals={pendingAccessRequests} hideFarmDetails={true} />}
                            {access && access.length > 0 && <FarmAccessList online={online} access={access} farm={farm} authContext={authContext} isPublicationAccess={false} />}
                            {access && access.length === 0 && !isLoading && (
                                <Panel title="Existing farm access" midBlue>
                                    <PanelBody>
                                        <TileBodyMessage>
                                            <img src={icons.add} alt="Plus" />
                                            <p className="lead">You have not granted any farm access for this farm</p>
                                            {online && !isStudent && (
                                                <ActionLink className="IconLink--arrow-plus Button Button--lg u-mt-lg" id="add-access-link" onClick={this._grantFarmAccess()}>
                                                    <span>Grant access</span>
                                                </ActionLink>
                                            )}
                                        </TileBodyMessage>
                                    </PanelBody>
                                </Panel>
                            )}
                        </PanelBody>
                    </Panel>
                </PageBody>
            </Page>
        );
    }
}

export default compose(withAppContext, withActions({ modal, fetchFarmAccess }))(FarmAccess);
